/*
 * Copyright © 2025 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {assertInInjectionContext, effect, inject} from '@angular/core';
import type {RouterParamsOptions} from './router-params-syncer.service';
import {RouterParamsSyncerService} from './router-params-syncer.service';

/**
 * A callback that returns a plain object with key/value pairs for router params. If it contains signals, the router
 * params will change when the signals change.
 */
type ParamsCallback = () => Record<string, unknown>;

/**
 * Runs in Angular injection context, tracks a computed router params object from signals,
 * and updates the router via StateService whenever they change.
 */
export function updateRouterParams(
    getParams: ParamsCallback,
    options: RouterParamsOptions & { skipFirstUpdate?: boolean } = {},
): void {
    assertInInjectionContext(updateRouterParams);

    const syncer = inject(RouterParamsSyncerService);

    let firstRun = true;

    effect(() => {
        const params = getParams();

        if (!options.skipFirstUpdate || !firstRun) {
            syncer.updateRouterParamsOnce(params, options);
        }

        // noinspection ReuseOfLocalVariableJS
        firstRun = false;
    });
}
